import { FC } from 'react';
import './styles/Footer.css';
import Logo from './components/Logo';

const webappUrl =
  process.env.REACT_APP_PABSYNC_WEBAPP_URL || 'https://app.pabsync.com';

const COLUMNS: { title: string; links: { label: string; href: string }[] }[] = [
  {
    title: 'Product',
    links: [
      { label: 'Overview', href: '/#why' },
      { label: 'Features', href: '/#features' },
      { label: 'How it works', href: '/#how' },
      { label: 'Integrations', href: '/#integrations' },
    ],
  },
  {
    title: 'Plans',
    links: [
      { label: 'Pricing', href: '/pricing' },
      { label: 'Start free', href: `${webappUrl}/register?plan=free&src=website` },
      { label: 'Log in', href: webappUrl },
      { label: 'Changelog', href: '/changelog' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Documentation', href: '/faq' },
      { label: 'FAQ', href: '/faq' },
      { label: 'Blog', href: '/blog' },
      { label: 'Security', href: '/security' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: '/about' },
      { label: 'Contact', href: '/contact' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
    ],
  },
];

const Footer: FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="ft" aria-label="Footer">
      <div className="ft__top">
        <div className="ft__brand">
          <a href="/" aria-label="PabSync home">
            <Logo size={30} />
          </a>
          <p className="ft__tagline">
            Human + AI work management for teams that ship.
          </p>
          <a
            className="btn btn--ghost btn--sm"
            href={`${webappUrl}/register?plan=free&src=website`}
          >
            Start free
          </a>
        </div>

        <div className="ft__cols">
          {COLUMNS.map((col) => (
            <nav className="ft__col" key={col.title} aria-label={col.title}>
              <h4>{col.title}</h4>
              <ul>
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href}>{l.label}</a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
      </div>

      <div className="ft__bottom">
        <span>© {year} Pabsoft. All rights reserved.</span>
        <nav className="ft__legal" aria-label="Legal">
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
          <a href="/cookies">Cookies</a>
          <a href="/subprocessors">Subprocessors</a>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
